import { IssueType } from '@issuemanager/constants';
import {
  IssueTypeFieldMode,
  getAllowedFieldsForIssueType,
  isIssueTypeSpecificField,
} from '@issuemanager/features/issue';
import { IssueRequestDto } from '@issuemanager/routes';

type SplitResult<T> = {
  baseValues: Partial<T>;
  typeSpecificValues: Partial<T>;
};

export function splitFormData<FormData extends IssueRequestDto>(
  formData: FormData,
  issueType: IssueType,
  mode: IssueTypeFieldMode,
): SplitResult<FormData> {
  const allowedFields = getAllowedFieldsForIssueType(issueType, mode);
  const formDataKeys = Object.keys(formData) as Array<keyof FormData>;

  return formDataKeys.reduce(
    (acc, key) => {
      const fieldValue = formData[key];
      const fieldName = String(key);

      if (fieldValue === undefined || fieldValue === null) {
        return acc;
      }

      if (isIssueTypeSpecificField(fieldName)) {
        if (allowedFields.includes(fieldName)) {
          acc.typeSpecificValues[key] = fieldValue;
        }
      } else {
        acc.baseValues[key] = fieldValue;
      }

      return acc;
    },
    {
      baseValues: {},
      typeSpecificValues: {},
    } as SplitResult<FormData>,
  );
}
